import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

export const TooltipProvider = TooltipPrimitive.Provider;
const TooltipRoot = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;
const TooltipContent = TooltipPrimitive.Content;
const TooltipPortal = TooltipPrimitive.Portal;

export interface TooltipProps {
  children: React.ReactNode;
  content: React.ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  sideOffset?: number;
  align?: 'start' | 'center' | 'end';
  /** Optional trigger className */
  triggerClassName?: string;
  /** Optional content className */
  contentClassName?: string;
  /** Delay in ms before showing (default 200) */
  delayDuration?: number;
}

export function Tooltip({
  children,
  content,
  side = 'top',
  sideOffset = 8,
  align = 'center',
  triggerClassName,
  contentClassName,
  delayDuration = 200,
}: TooltipProps) {
  return (
    <TooltipRoot delayDuration={delayDuration}>
      <TooltipTrigger asChild>
        <span className={triggerClassName}>{children}</span>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent
          side={side}
          sideOffset={sideOffset}
          align={align}
          className={`tooltip-content ${contentClassName ?? ''}`.trim()}
          avoidCollisions
        >
          {content}
        </TooltipContent>
      </TooltipPortal>
    </TooltipRoot>
  );
}
